import { render, staticRenderFns } from "./06_3_3_OtherBodyForm.vue?vue&type=template&id=0868438d&"
import script from "./06_3_3_OtherBodyForm.vue?vue&type=script&lang=js&"
export * from "./06_3_3_OtherBodyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports